import PropTypes from 'prop-types';

const SearchInterface = {
  resultType: PropTypes.oneOf([
    'CONTENT',
    'DOCUMENT',
    'USER',
    'ASSOCIATION',
    'FOLDER'
  ]),
  id: PropTypes.string,
  imageName: PropTypes.string,
  imagePath: PropTypes.string,
  subtitle: PropTypes.string,
  creationDate: PropTypes.string,
  title: PropTypes.string
};

export const SearchModel = PropTypes.shape({
  ...SearchInterface
});
